// this is ported from client v1

export const dynamicPrecision = (v: number, threshold = 0.9999) => {
  let shift = 1;
  let part;

  do {
    shift *= 10;
    part = Math.floor(v * shift) / shift;
  } while (part / v < threshold);

  return part;
};

export const prettySizes = (size: number, appendUnit = true) => {
  const magnitude = Math.log10(Math.abs(size));
  if (magnitude === -Infinity || magnitude === Infinity) {
    return `0`;
  }
  // Check if planck length
  if (magnitude < -24) {
    return `${dynamicPrecision(size * 10 ** 35)}${appendUnit ? ' ℓP' : ''}`;
  }
  // Check if ym
  if (magnitude < -21) {
    return `${dynamicPrecision(size * 10 ** 24)}${appendUnit ? ' ym' : ''}`;
  }
  // Check if zm
  if (magnitude < -18) {
    return `${dynamicPrecision(size * 10 ** 21)}${appendUnit ? ' zm' : ''}`;
  }
  // Check if am
  if (magnitude < -15) {
    return `${dynamicPrecision(size * 10 ** 18)}${appendUnit ? ' am' : ''}`;
  }
  // Check if fm
  if (magnitude < -12) {
    return `${dynamicPrecision(size * 10 ** 15)}${appendUnit ? ' fm' : ''}`;
  }
  // Check if pm
  if (magnitude < -9) {
    return `${dynamicPrecision(size * 10 ** 12)}${appendUnit ? ' pm' : ''}`;
  }
  // Check if nm
  if (magnitude < -6) {
    return `${dynamicPrecision(size * 10 ** 9)}${appendUnit ? ' nm' : ''}`;
  }
  // Check if um
  if (magnitude < -4) {
    return `${dynamicPrecision(size * 1000000)}${appendUnit ? ' μm' : ''}`;
  }
  // Check if mm
  if (magnitude < -3) {
    return `${dynamicPrecision(size * 1000)}${appendUnit ? ' mm' : ''}`;
  }
  // handle cm
  if (magnitude < -1) {
    return `${dynamicPrecision(size * 100)}${appendUnit ? ' cm' : ''}`;
  }
  // handle Em
  if (magnitude >= 18) {
    return `${dynamicPrecision(size / 10 ** 18)}${appendUnit ? ' Em' : ''}`;
  }
  // handle Pm
  if (magnitude >= 15) {
    return `${dynamicPrecision(size / 10 ** 15)}${appendUnit ? ' Pm' : ''}`;
  }
  // handle Gm
  if (magnitude >= 12) {
    return `${dynamicPrecision(size / 10 ** 12)}${appendUnit ? ' Tm' : ''}`;
  }
  // handle Gm
  if (magnitude >= 9) {
    return `${dynamicPrecision(size / 10 ** 9)}${appendUnit ? ' Gm' : ''}`;
  }
  // handle Mm
  if (magnitude >= 6) {
    return `${dynamicPrecision(size / 10 ** 6)}${appendUnit ? ' Mm' : ''}`;
  }
  // handle km
  if (magnitude >= 3) {
    return `${dynamicPrecision(size / 1000)}${appendUnit ? ' km' : ''}`;
  }
  // handle m
  if (magnitude >= -1) {
    return `${dynamicPrecision(size)}${appendUnit ? ' m' : ''}`;
  }
  // we dont know
  return dynamicPrecision(size);
};

export const prettyUnits = (size: number) => {
  const magnitude = Math.log10(Math.abs(size));
  if (magnitude === -Infinity || magnitude === Infinity) {
    return `Inf`;
  }
  // Check if planck length
  if (magnitude < -24) {
    return `ℓP`;
  }
  // Check if ym
  if (magnitude < -21) {
    return `ym`;
  }
  // Check if zm
  if (magnitude < -18) {
    return `zm`;
  }
  // Check if am
  if (magnitude < -15) {
    return `am`;
  }
  // Check if fm
  if (magnitude < -12) {
    return `fm`;
  }
  // Check if pm
  if (magnitude < -9) {
    return `pm`;
  }
  // Check if nm
  if (magnitude < -6) {
    return `nm`;
  }
  // Check if um
  if (magnitude < -4) {
    return `μm`;
  }
  // Check if mm
  if (magnitude < -3) {
    return `mm`;
  }
  // handle cm
  if (magnitude < -1) {
    return `cm`;
  }
  // handle Em
  if (magnitude >= 18) {
    return `Em`;
  }
  // handle Pm
  if (magnitude >= 15) {
    return `Pm`;
  }
  // handle Gm
  if (magnitude >= 12) {
    return `Tm`;
  }
  // handle Gm
  if (magnitude >= 9) {
    return `Gm`;
  }
  // handle Mm
  if (magnitude >= 6) {
    return `Mm`;
  }
  // handle km
  if (magnitude >= 3) {
    return `km`;
  }
  // handle m
  if (magnitude >= -1) {
    return `m`;
  }
};
